// React
import { memo, useEffect, useRef } from "react";

import { GOOGLE_BUTTON_CONFIG, GOOGLE_CLIENT_ID, GOOGLE_SCRIPT_URL } from "./consts";
import { GoogleSignInButtonProps } from "./types";

/**
 * Gumb „Prijava Google računom". Gumb crta sam Google, jer je njegov izgled dio uvjeta korištenja,
 * a i odabir računa mora ići kroz njihov prozor. Nama se vrati potpisani token, koji provjerava
 * poslužitelj — preglednik ovdje ništa ne dokazuje sam.
 */
const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = (props) => {
  const { onCredential } = props;

  const containerRef = useRef<HTMLDivElement | null>(null);

  // Skripta se pamti u samom dokumentu, da se ne učitava iznova pri svakom otvaranju prijave.
  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) return;

    const existing = document.querySelector<HTMLScriptElement>(`script[src="${GOOGLE_SCRIPT_URL}"]`);

    if (existing) {
      renderButton();
      return;
    }

    const script = document.createElement("script");
    script.src = GOOGLE_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = renderButton;

    document.body.appendChild(script);
  }, []);

  const renderButton = () => {
    const google = (window as any).google;

    if (!google?.accounts?.id || !containerRef.current) return;

    google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: (response: { credential?: string }) => {
        if (response?.credential) onCredential(response.credential);
      },
    });

    google.accounts.id.renderButton(containerRef.current, GOOGLE_BUTTON_CONFIG);
  };

  // Bez podešenog identifikatora prijava se ne nudi — inače bi gumb samo javljao grešku.
  if (!GOOGLE_CLIENT_ID) return null;

  return (
    <>
      <div className="flex items-center gap-3 my-4">
        <span className="h-px flex-1 bg-slate-200" />
        <span className="text-sm text-slate-400">ili</span>
        <span className="h-px flex-1 bg-slate-200" />
      </div>

      {/* Google nudi samo tri visine gumba, a najviša je niža od naše — pa se gumbu koji on
          nacrta visina i zaobljenje izjednače s našim „Prijava". */}
      <div
        ref={containerRef}
        className="flex justify-center [&_div[role=button]]:!h-[56px] [&_div[role=button]]:!rounded-md"
      />
    </>
  );
};

export default memo(GoogleSignInButton);
